module.exports = __webpack_public_path__ + "img/payments.856b1257.png";